import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

import { getColor } from './color'

interface DiscountProps extends ChipProps {
  discount: {
    context?: string
    percentage?: number
  }
}

const legacyWordbook = (context: string) => {
  switch (context) {
    case 'bundle_offer':
      return 'common:BUNDLE_OFFER_PRODUCT_TAG'
    case 'outlet':
      return 'outlet'
    default:
      return ''
  }
}

const LegacyDiscountChip: FC<DiscountProps> = ({
  discount,
  size = 'medium',
}) => {
  const { t } = useTranslation()
  const {
    context = '',
    percentage = 0,
  } = discount

  const label = t(legacyWordbook(context))

  if (!label) {
    return null
  }

  const color = getColor(context)
  const isDiscount = (percentage || 0) > 0
  const percentageLabel = isDiscount ? `-${percentage}%` : ''
  const separator = label !== '' && isDiscount ? ' ' : ''

  return (
    <Chip color={color} size={size}>
      {color === 'red' ? `${label}${separator}${percentageLabel}` : `${percentageLabel}${separator}${label}`}
    </Chip>
  )
}

export const DiscountChip: FC<DiscountProps> = ({
  discount,
  size = 'medium',
}) => {
  const { t } = useTranslation()

  const {
    context = '',
    percentage = 0,
  } = discount
  const label = t('common:discount_chip', {
    context,
    discountPercentage: percentage,
  })
  const color = getColor(context)
  if (label === 'discount_chip') {
    return <LegacyDiscountChip discount={discount} size={size} />
  }

  if (!label) {
    return null
  }

  return (
    <Chip color={color} size={size}>
      {label}
    </Chip>
  )
}

